import { Modal, Pressable, ScrollView, StyleSheet, View } from "react-native";
import { forwardRef, ReactNode } from "react";

export interface PopupMenuRef {
  close: () => void;
}

type Props = {
  visible: boolean;
  onClose: () => void;
  position: { top: number; left: number };
  children: ReactNode;
};

export const PopupMenu = forwardRef<PopupMenuRef, Props>(
  ({ visible, onClose, position, children }: Props) => {
    return (
      <Modal
        visible={visible}
        transparent
        animationType="none"
        onRequestClose={onClose}
      >
        <Pressable
          onPress={onClose}
          className="absolute left-0 top-0 right-0 bottom-0 "
        ></Pressable>

        <View
          style={[
            styles.position,
            {
              top: position.top,
              left: position.left,
            },
          ]}
          className="rounded-md shadow-md w-fit bg-white"
        >
          <ScrollView className="max-h-[400px] p-2.5">{children}</ScrollView>
        </View>
      </Modal>
    );
  },
);

const styles = StyleSheet.create({
  position: {
    position: "absolute",
    zIndex: 10,
  },
});

PopupMenu.displayName = "PopupMenu";
